export async function loadConfig() {
  const timestamp = new Date().getTime();
  const configUrl = `${window.location.origin}/basic-auth/config/config.json?version=${timestamp}`;
  const response = await fetch(configUrl);
  if (!response.ok) {
    throw new Error(`Impossibile caricare config.json: ${response.status}`);
  }
  const config = await response.json();
  return config;
}
